import { render } from "./XChooseYDialog.vue?vue&type=template&id=078d4ade&scoped=true"
import script from "./XChooseYDialog.vue?vue&type=script&lang=js"
export * from "./XChooseYDialog.vue?vue&type=script&lang=js"

import "./XChooseYDialog.vue?vue&type=style&index=0&id=078d4ade&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078d4ade"]])

export default __exports__